import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    convertUniversalDateToPersianDate,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage,
    RaikoDefaultDialogPage,
    DialogSize,
    RaikoGridTwoColumn,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneStatusTypes, RaikoGridThreeColumn
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import AddNewPeriod from "./addNewPeriod/AddNewPeriod";
import {useNavigate} from "react-router-dom";

export default function PeriodList() {

    let page = 0;
    const size = 20;

    const service = new PeriodService()

    const [periodListData, setPeriodListData] = useState([]);
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);


    useEffect(() => {
        if (service) {
            getPeriodListFromServer()
        }
    }, [])

    function periodListRow(
        id,
        number,
        periodName,
        numberOffDaysAllowed,
        startDate,
        endDate,
        acceptation,
        automaticAcceptance,
        createdBy,
        createdAt
    ) {
        return {
            id,
            number,
            periodName,
            numberOffDaysAllowed,
            startDate: convertUniversalDateToPersianDate(startDate),
            endDate: convertUniversalDateToPersianDate(endDate),
            acceptation: acceptation ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            acceptationStatus: acceptation,
            automaticAcceptance: automaticAcceptance ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
        }
    }


    function getPeriodListFromServer() {
        setIsLoading(true)
        service.getPeriodList(page, size)
            .then(response => {

                setPageCount(response.totalPage)
                setPeriodListData([])
                setNumberOfItems(response.numberOfItems)
                response.data.map((item, index) => {
                    setPeriodListData(prevState => [
                        ...prevState,
                        periodListRow(
                            item.id,
                            (page * size) + index + 1,
                            item.metaData.title,
                            item.numberOfDaysAllowed,
                            item.startDate,
                            item.endDate,
                            item.acceptation,
                            item.automaticAcceptance,
                            item.createdBy,
                            item.createdAt,
                        )
                    ])
                })

                setIsLoading(false)
            }).catch(reason => {
            showServerErrorMessage(reason)
            setIsLoading(false)
        }).finally(() => {
            setIsLoading(false)
        })
    }


    function handleChangePage(newPage) {
        page = newPage;
        getPeriodListFromServer()
    }

    //modal-start
    const [openAddPeriodDialog, setOpenAddPeriodDialog] = useState(false)


    function handleOpenAddPeriodModal() {
        setOpenAddPeriodDialog(true)
    }

    function handleCloseAddPeriodModal() {
        setOpenAddPeriodDialog(false)
        page = 0
        getPeriodListFromServer()
    }

    //modal-end

    const navigate = useNavigate()


    function handleShowPeriodDetail(id) {
        let _title = ""
        periodListData.map((item) => {
            if (item.id === id)
                _title = item.periodName
        })

        navigate(RouteHelper.PeriodDetails.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }

    const [selectDisplayType, setSelectDisplayType] = useState(false)
    return (
        <>
            <Helmet><title>{RouteHelper.PeriodList.name}</title></Helmet>
            <RaikoDefaultDialogPage
                pageTitle={""}
                onClose={handleCloseAddPeriodModal}
                open={openAddPeriodDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <AddNewPeriod/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Habitation.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.PeriodList.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اسکان دهی"}
                            amount={numberOfItems}
                            hasCreateNewItem={true}
                            handleCreateNewItem={handleOpenAddPeriodModal}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoCustomTable
                            header={periodListHeader}
                            data={periodListData}
                            isLoading={isLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePage}
                            rowClicked={handleShowPeriodDetail}
                            selectDisplayType={selectDisplayType}
                        >
                            <RaikoGridTwoColumn className={css`padding: 3px`}>
                                {
                                    periodListData.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            iconClass={"ic_residence"}
                                            title={item.periodName}
                                            status
                                            statusText={item.acceptationStatus ? "پذیرش" : "عدم پذیرش"}
                                            statusType={item.acceptationStatus ? RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                                            titleLabel={` ${item.startDate}   الـــــــی  ${item.endDate} `}
                                            onClick={() => {
                                                handleShowPeriodDetail(item.id)
                                            }}
                                        />
                                    })
                                }


                            </RaikoGridTwoColumn>
                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}
const AcceptationTypes = {
    acceptation: {
        id: "acceptation",
        title: "پذیرش"
    },
}
const periodListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "periodName",
        label: "نام دوره زمانی"
    },
    {
        id: "numberOffDaysAllowed",
        label: "حداکثر روز اقامت"
    },
    {
        id: "startDate",
        label: "تاریخ شروع",
    },
    {
        id: "endDate",
        label: "تاریخ پایان"
    },
    {
        id: "acceptation",
        label: "پذیرش"
    },
    {
        id: "automaticAcceptance",
        label: "بررسی خودکار"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]